'use client';

import React, {useState, useEffect, ReactNode} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight} from "@fortawesome/pro-regular-svg-icons";


interface NavLinkProps {
    label: string;
    children: ReactNode;
}

export default function MobileNavLink(props: NavLinkProps) {

    const [menuSectionOpen, setMenuSectionOpen] = useState(false);

    useEffect(() => {
        const list = [
            "overflow-hidden",
            "max-h-screen",
            "overscroll-none",
            "lg:overflow-auto",
            "lg:max-h-auto",
        ];
        document.body.classList.add(...list);
        return () => {
            document.body.classList.remove(...list);
        };
    }, []);

    return (
        <>
            <li className={"cursor-pointer border-b"}>
                <div
                    onClick={() => setMenuSectionOpen(true)}
                    className={`flex items-center p-5 text-lg`}
                >
                    {props.label}
                    <FontAwesomeIcon
                        icon={faArrowRight}
                        className={"ml-auto"}
                    />
                </div>
            </li>
            <div
                className={`fixed top-0 left-0 right-0 h-screen z-10 transform overflow-scroll overflow-x-hidden bg-white transition duration-200 ease-in-out ${
                    menuSectionOpen ? "translate-x-0" : "translate-x-full"
                }`}
            >
                <div className="bg-white h-[84px] py-6 z-50">
                    <div className="container flex items-center justify-start">

                        <div
                            className="bg-[#EDEBFA] min-w-[35px] min-h-[35px]  cursor-pointer relative top-[3px] left-[10px] rounded-full flex items-center justify-center mr-[7px]"
                            onClick={() => setMenuSectionOpen(false)}
                        >
                            <FontAwesomeIcon icon={faArrowLeft} className="text-[#473BD0] text-lg relative top-[-1px]" />
                        </div>

                    </div>
                </div>
                {props.children}
            </div>
        </>
    );
}
